<script>
import ModalComponent from "../modals/ModalComponent.vue";
import moment from "moment";

export default {
    name: "ActivityLogComponent",
    components: {ModalComponent},
    inheritAttrs: false,
    props: {
        model: {
            type: String,
            required: true,
        },
        id: {
            type: [String, Number],
            required: true,
        },
        small: {
            type: Boolean,
            default: false,
        },
        buttonClass: {
            type: [String, Array, Object],
            default: '',
        },
    },
    data: function () {
        return {
            activityLogs: [],
            showModal: false,
            loading: false,
        };  
    },
    computed: {
        modalTitle: function () {
            return `Activity Logs for ${this.model} #${this.id}`
        },
    },
    methods: {
        showActivityLogs: function () {
            this.loading = true;
            this.$refs.modal.open();
            window.axios.get('/api/activity-logs', {
                params: {
                    model: this.model,
                    id: this.id,
                },
            }).then((response) => {
                this.activityLogs = response.data.map(activityLog => ({
                    ...activityLog,
                    created_at: moment(activityLog.created_at),
                }));
                this.loading = false;
            })
        }
    },
}
</script>

<template>
    <div class="d-inline-block position-relative text-left">
        <button
            type="button"
            @click.prevent="showActivityLogs"
            class="btn btn-info"
            :class="[buttonClass, { 'btn-sm': small, }]"
            title="View activity logs"
            v-bind="$attrs"
        >
            <i class="fa fa-fingerprint" />
            <span v-if="!small">Logs</span>
        </button>
        <modal-component
            :title="modalTitle"
            ref="modal"
        >
            <p v-if="loading">
                <i class="fa fa-spinner fa-spin" />
                Loading activity logs...
            </p>
            <p v-else-if="!activityLogs.length">
                No activity to show yet
            </p>
            <table
                class="w-full"
                v-else
            >
                <tr
                    v-for="activityLog in activityLogs"
                    :key="activityLog.id"
                    class="activity-row"
                >
                    <td>
                        <span class="font-weight-bold">{{ activityLog.description }}</span>
                        {{ ` by ${activityLog.causer.name || 'system'}` }}
                    </td>

                    <td
                        class="font-italic pl-4"
                        style="font-size: .75em"
                    >
                        {{ activityLog.created_at.format('DD/MM/YYYY HH:mm:ss') }}
                    </td>
                </tr>
            </table>
        </modal-component>
    </div>
</template>

<style lang="scss">
.activity-row {
    border-bottom: 1px solid #ebebeb;

    td {
        padding: .5rem .25rem;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/activityLogs/ActivityLogComponent.vue